import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './auth/authConfig';
import { App } from './App';
import './styles/tokens.css';
import './styles/index.css';

const msalInstance = new PublicClientApplication(msalConfig);

async function bootstrap(): Promise<void> {
  await msalInstance.initialize();

  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Root container #root not found');
  }

  createRoot(container).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </StrictMode>,
  );
}

void bootstrap();
